import React, { Component } from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import Login from '../View/Login';
import BG from '../images/table5IconBg.svg';
import '../css/table.css';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share'
const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');

class Table5 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      send: false,
      loading: false,
      ans1: false,
      ans2: false,
      ans3: false,
      ans4: false,
      ans5: false,
      ans6: false,
      ans7: false,
      ans8: false,
      ans9: false,
      ans10: false,
      ans11: false,
      ans12: false,
      name: '壓力自我診斷',
      totalTest:'',
      url: 'herbalcure.com.tw/Table5',
      thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa',
      fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa'
    }
    this.tableBox = this.tableBox.bind(this)
    this.handleChangeAns1 = this.handleChangeAns1.bind(this)
    this.handleChangeAns2 = this.handleChangeAns2.bind(this)
    this.handleChangeAns3 = this.handleChangeAns3.bind(this)
    this.handleChangeAns4 = this.handleChangeAns4.bind(this)
    this.handleChangeAns5 = this.handleChangeAns5.bind(this)
    this.handleChangeAns6 = this.handleChangeAns6.bind(this)
    this.handleChangeAns7 = this.handleChangeAns7.bind(this)
    this.handleChangeAns8 = this.handleChangeAns8.bind(this)
    this.handleChangeAns9 = this.handleChangeAns9.bind(this)
    this.handleChangeAns10 = this.handleChangeAns10.bind(this)
    this.handleChangeAns11 = this.handleChangeAns11.bind(this)
    this.handleChangeAns12 = this.handleChangeAns12.bind(this)
    this.goToTable2 = this.goToTable2.bind(this)
    this.goToTable3 = this.goToTable3.bind(this)
    this.goToTable4 = this.goToTable4.bind(this)
    this.goToTable5 = this.goToTable5.bind(this)
    this.goToTable6 = this.goToTable6.bind(this)
    this.tableSave = this.tableSave.bind(this)
  }
  componentDidMount() {
    window.scrollTo(0,0)
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        const totalTestTableRef = firebase.database().ref().child('total')
        totalTestTableRef.on('value', snap => {
          this.setState({
            totalTest: snap.val().totalTest
          })
        })
       console.log(this.state.totalTest)
      } else {
        tableBox.classList.remove('isShow')
      }
    })
  }
  tableBox() {
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        scrollToComponent(tableBox, {
        	offset: -50,
        	align: 'top',
        	duration: 700
        })
      } else {
        tableBox.classList.remove('isShow')
        this.setState({ send: true})
        setTimeout(() => this.setState({ loading: true }), 400);
      }
    })
  }
  goToTable2() {
    const table1 = ReactDOM.findDOMNode(this.refs.table1)
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    table1.classList.remove('isShow')
    table2.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is17')
  }
  goToTable3() {
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    table2.classList.remove('isShow')
    table3.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is34')
  }
  goToTable4() {
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    table3.classList.remove('isShow')
    table4.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is51')
  }
  goToTable5() {
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    table4.classList.remove('isShow')
    table5.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is68')
  }
  goToTable6() {
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    const table6 = ReactDOM.findDOMNode(this.refs.table6)
    table5.classList.remove('isShow')
    table6.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is85')
  }
  tableSave(event) {
    event.preventDefault()
    const totalTestTableRef = firebase.database().ref().child('total')
    totalTestTableRef.update({
      totalTest: (this.state.totalTest * 1) + 1
    })
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.add('is100')
    const userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('users/').child(userId).child('Answers').push()
    const postId = rootRef.key
    const total = ((this.state.ans1 * 1) + (this.state.ans2 * 1) + (this.state.ans3 * 1) + (this.state.ans4 * 1) + (this.state.ans5 * 1) + (this.state.ans6 * 1) + (this.state.ans7 * 1) + (this.state.ans8 * 1) + (this.state.ans9 * 1) + (this.state.ans10 * 1) + (this.state.ans11 * 1) + (this.state.ans12 * 1))
    if (total < 24) {
      rootRef.update({
        Reviews: '您的壓力指數還在能負荷的範圍。繼續保持喔',
        ans: total,
        name: '壓力自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table5',
        localUrl: '/Table5',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa'
      })
    } else if (total < 40) {
      rootRef.update({
        Reviews: '壓力滿困擾您，雖能勉強應付，但必需認真學習壓力管理了，同時多與良師益友聊一聊。',
        ans: total,
        name: '壓力自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table5',
        localUrl: '/Table5',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa'
      })
    } else if (total < 64) {
      rootRef.update({
        Reviews: '您的壓力很大，趕快去看心理衛生專業人員，接受系統性的心理治療。',
        ans: total,
        name: '壓力自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table5',
        localUrl: '/Table5',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa'
      })
    } else {
      rootRef.update({
        Reviews: '您的壓力已很嚴重，應該看精神專科醫師，依醫師處方用藥物治療與心理治療，幫忙您的生活趕快恢復正常軌道。',
        ans: total,
        name: '壓力自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table5',
        localUrl: '/Table5',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable5.jpg?alt=media&token=769312a2-87d8-4d94-9c34-5f745dbe74fa'
      })
    }
    window.location = ('/Answer/' + postId);
  }
  handleChangeAns1(event) {
    this.setState({ans1: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.add('is8-3')
    const toQ2 = ReactDOM.findDOMNode(this.refs.toQ2)
    scrollToComponent(toQ2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns2(event) {
    this.setState({ans2: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is8-3')
    sliderBar.classList.add('is16-6')
    const toNext1 = ReactDOM.findDOMNode(this.refs.toNext1)
    scrollToComponent(toNext1, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns3(event) {
    this.setState({ans3: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is16-6')
    sliderBar.classList.add('is24-9')
    const toQ4 = ReactDOM.findDOMNode(this.refs.toQ4)
    scrollToComponent(toQ4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns4(event) {
    this.setState({ans4: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is24-9')
    sliderBar.classList.add('is33-2')
    const toNext2 = ReactDOM.findDOMNode(this.refs.toNext2)
    scrollToComponent(toNext2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns5(event) {
    this.setState({ans5: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is33-2')
    sliderBar.classList.add('is41-5')
    const toQ6 = ReactDOM.findDOMNode(this.refs.toQ6)
    scrollToComponent(toQ6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns6(event) {
    this.setState({ans6: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is41-5')
    sliderBar.classList.add('is49-8')
    const toNext3 = ReactDOM.findDOMNode(this.refs.toNext3)
    scrollToComponent(toNext3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns7(event) {
    this.setState({ans7: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is49-8')
    sliderBar.classList.add('is58-1')
    const toQ8 = ReactDOM.findDOMNode(this.refs.toQ8)
    scrollToComponent(toQ8, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns8(event) {
    this.setState({ans8: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is58-1')
    sliderBar.classList.add('is66-4')
    const toNext4 = ReactDOM.findDOMNode(this.refs.toNext4)
    scrollToComponent(toNext4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns9(event) {
    this.setState({ans9: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is66-4')
    sliderBar.classList.add('is74-7')
    const toQ10 = ReactDOM.findDOMNode(this.refs.toQ10)
    scrollToComponent(toQ10, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns10(event) {
    this.setState({ans10: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is74-7')
    sliderBar.classList.add('is83')
    const toNext5 = ReactDOM.findDOMNode(this.refs.toNext5)
    scrollToComponent(toNext5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns11(event) {
    this.setState({ans11: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is83')
    sliderBar.classList.add('is91-3')
    const toQ12 = ReactDOM.findDOMNode(this.refs.toQ12)
    scrollToComponent(toQ12, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns12(event) {
    this.setState({ans12: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is91-3')
    sliderBar.classList.add('is100')
    const toNext6 = ReactDOM.findDOMNode(this.refs.toNext6)
    scrollToComponent(toNext6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  render(postId) {
    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9',justifyContent: 'center', alignItems:'center'}} >
        <Login />
      </div>
    }
    const nextBtn1 = ((this.state.ans1 + this.state.ans2) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable2}>下一題</div>
     : null
    const nextBtn2 = ((this.state.ans3 + this.state.ans4) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable3}>下一題</div>
     : null
    const nextBtn3 = ((this.state.ans5 + this.state.ans6) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable4}>再接再厲</div>
     : null
    const nextBtn4 = ((this.state.ans7 + this.state.ans8) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable5}>下一題</div>
     : null
    const nextBtn5 = ((this.state.ans9 + this.state.ans10) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable6}>再接再厲</div>
     : null
    const nextBtn6 = ((this.state.ans11 + this.state.ans12) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.tableSave}>完成!提交吧</div>
     : null
    return (
      <div>
        <MetaTags>
            <title>草學藥事 || {this.state.name}</title>
            <meta id="og-title" property="og:title" content={this.state.name} />
        </MetaTags>
        <div className="animationBox" style={Jeyu.Banner} ref="banner">
         <div className="container">
          <div className="row">
          <div style={Jeyu.Slogan} className="slogan table5">
           <h1>每天都處在壓力環境?</h1>
           <h2>適度放鬆 平衡身心</h2>
           <p className="moileNone">
           主管交辦事項永遠做不完，每天都在跟時間賽跑<br />
           身上的重擔太多，健康開始出現警訊<br />
           計畫一趟旅遊，讓壓抑已久的心靈獲得釋放吧~
           </p>
           <span className="tableBtnDefault" onClick={this.tableBox}>開始檢測</span>
           <article className="fbBox">
                  <div className="Demo__some-network">
                     <FacebookShareButton
                       url='https://herbalcure.com.tw/Table5'
                       quote={this.state.name}
                       className="Demo__some-network__share-button">
                       <FacebookIcon
                         size={26}
                         round />
                     </FacebookShareButton>
                   </div>
                   <div className="Demo__some-network">
                     <GooglePlusShareButton
                       url='https://herbalcure.com.tw/Table5'
                       className="Demo__some-network__share-button">
                       <GooglePlusIcon
                         size={26}
                         round />
                     </GooglePlusShareButton>
                   </div>
           </article>
          </div>
          </div>
         </div>
        </div>
        <div className="tableBox table2Height" ref="tableBox" style={Jeyu.tableBox}>
         <div className="container">
          <div className="row">
          <div className="tableFlexBox">
           <div className="mobilePd20">
            <h2>壓力自我診斷</h2>
            <sub>請您根據最近兩週的狀態，選擇適當答案。<br />
              表格引用(衛生福利部國民健康署)
            </sub>
           </div>
            <div className="sliderBar" ref="sliderBar"></div>
            <section className="">
             <form className="tableForm">
             <div className="table1 isShow" ref="table1">
              <article ref="toQ2">
               <h1>Q1:您最近是否經常感到緊張，覺得工作總是做不完?</h1>
               <input type="radio" value='8'
                id="ans1"
                checked={this.state.ans1 === '8'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans1">是</label>
               <input type="radio" value='1'
                id="ans2"
                checked={this.state.ans1 === '1'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans2">否</label>
              </article>
              <article ref="toNext1">
               <h1>Q2:您最近是否老是睡不好，常常失眠或睡眠品質不佳?</h1>
               <input type="radio" value='8'
                id="ans3"
                checked={this.state.ans2 === '8'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans3">是</label>
               <input type="radio" value='1'
                id="ans4"
                checked={this.state.ans2 === '1'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans4">否</label>
              </article>
               <div>{ nextBtn1 }</div>
              </div>
              <div className="table2" ref="table2">
              <article ref="toQ4">
               <h1>Q3:您最近是否經常有情緒低落、焦慮、煩躁的情況?</h1>
               <input type="radio" value='8'
                id="ans5"
                checked={this.state.ans3 === '8'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans5">是</label>
               <input type="radio" value='1'
                id="ans6"
                checked={this.state.ans3 === '1'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans6">否</label>
              </article>
              <article ref="toNext2">
               <h1>Q4:您最近是否經常忘東忘西、變得很健忘?</h1>
               <input type="radio" value='8'
                id="ans7"
                checked={this.state.ans4 === '8'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans7">是</label>
               <input type="radio" value='1'
                id="ans8"
                checked={this.state.ans4 === '1'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans8">否</label>
              </article>
               <div>{ nextBtn2 }</div>
              </div>
              <div className="table3" ref="table3">
              <article ref="toQ6">
               <h1>Q5:您最近是否經常覺得胃口不好？或胃口特別好?</h1>
               <input type="radio" value='8'
                id="ans9"
                checked={this.state.ans5 === '8'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans9">是</label>
               <input type="radio" value='1'
                id="ans10"
                checked={this.state.ans5 === '1'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans10">否</label>
              </article>
              <article ref="toNext3">
               <h1>Q6:您最近六個月內是否生病不只一次了?</h1>
               <input type="radio" value='8'
                id="ans11"
                checked={this.state.ans6 === '8'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans11">是</label>
               <input type="radio" value='1'
                id="ans12"
                checked={this.state.ans6 === '1'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans12">否</label>
              </article>
               <div>{ nextBtn3 }</div>
              </div>
              <div className="table4" ref="table4">
              <article ref="toQ8">
               <h1>Q7:您最近是否經常覺得很累，假日都在睡覺?</h1>
               <input type="radio" value='8'
                id="ans13"
                checked={this.state.ans7 === '8'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans13">是</label>
               <input type="radio" value='1'
                id="ans14"
                checked={this.state.ans7 === '1'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans14">否</label>
              </article>
              <article ref="toNext4">
               <h1>Q8:您最近是否經常覺得頭痛、腰痠背痛?</h1>
               <input type="radio" value='8'
                id="ans15"
                checked={this.state.ans8 === '8'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans15">是</label>
               <input type="radio" value='1'
                id="ans16"
                checked={this.state.ans8 === '1'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans16">否</label>
              </article>
               <div>{ nextBtn4 }</div>
              </div>
              <div className="table5" ref="table5">
              <article ref="toQ10">
               <h1>Q9:您最近是否經常意見和別人不同?</h1>
               <input type="radio" value='8'
                id="ans17"
                checked={this.state.ans9 === '8'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans17">是</label>
               <input type="radio" value='1'
                id="ans18"
                checked={this.state.ans9 === '1'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans18">否</label>
              </article>
              <article ref="toNext5">
               <h1>Q10:您最近是否注意力經常難以集中?</h1>
               <input type="radio" value='8'
                id="ans19"
                checked={this.state.ans10 === '8'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans19">是</label>
               <input type="radio" value='1'
                id="ans20"
                checked={this.state.ans10 === '1'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans20">否</label>
              </article>
               <div>{ nextBtn5 }</div>
              </div>
              <div className="table6" ref="table6">
              <article ref="toQ12">
               <h1>Q11:您最近是否經常覺得未來充滿不確定感與恐懼感?</h1>
               <input type="radio" value='8'
                id="ans21"
                checked={this.state.ans11 === '8'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans21">是</label>
               <input type="radio" value='1'
                id="ans22"
                checked={this.state.ans11 === '1'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans22">否</label>
              </article>
              <article ref="toNext6">
               <h1>Q12:有人說您最近氣色不太好嗎?</h1>
               <input type="radio" value='8'
                id="ans23"
                checked={this.state.ans12 === '8'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans23">是</label>
               <input type="radio" value='1'
                id="ans24"
                checked={this.state.ans12 === '1'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans24">否</label>
              </article>
               <div>{ nextBtn6 }</div>
              </div>
             </form>
            </section>
            </div>
          </div>
         </div>
        </div>
      </div>
    )
  }
}

export default Table5;

const Jeyu = {
  Banner: {
    background: 'url('+BG+') center center/ 120%',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Slogan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid #325aaa',
    textAlign: 'center',
    padding: '20px 40px',
    flexDirection: 'column'
  },
  tableBox: {
    background: '#1ecf7e'
  }
}



// WEBPACK FOOTER //
// ./src/Tables/table5.js